import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__b5j0w","backdrop":"styles_backdrop__urvCb","visible":"styles_visible__i1tVN","header":"styles_header__9Imva","body":"styles_body__RIgTa"};
export const b = b_.with('overlay');